"use client";

import { c as _c } from "react/compiler-runtime";
import Cookies from "js-cookie";
import { useState } from "react";
import { getAuthBackend } from "@/lib/authBackend/resolve";
export function useEmsNotEntitledPage() {
  const $ = _c(3);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = async () => {
      setIsLoggingOut(true);
      ;
      try {
        await getAuthBackend().signOut({
          global: true
        });
      } catch (t1) {
        const error = t1;
        console.error("Sign out error:", error);
      }
      Cookies.set("x-org-id", "", {
        path: "/",
        maxAge: 0
      });
      Cookies.set("x-team-id", "", {
        path: "/",
        maxAge: 0
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleSignOut = t0;
  let t1;
  if ($[1] !== isLoggingOut) {
    t1 = {
      handleSignOut,
      isLoggingOut
    };
    $[1] = isLoggingOut;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}